<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
                <h2 style="font-size: 1.2vw !important;width: 14vw;">لیست سازمان های تابعه</h2>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;"
                       placeholder="جستجو بر اساس نام شرکت...">
              </div>
              <hr>
            </div>
            <div class="table-responsive mt-3">
              <div v-if="!all_users.length" style="text-align: center;">
                شرکتی یافت نشد
              </div>
              <div style="overflow-y: scroll; height: 50vw;" :style="all_users.length < 19 ? 'height: auto;' : ''">

                <table v-if="all_users.length" class="table table-striped">
                  <thead>
                  <tr>
                    <th style="width: 1vw;">ردیف</th>
                    <th>نام</th>
                    <th style="width: 17vw;"> مشاهده</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in filteredItems" :key="item.id">
                    <td scope="row">{{ index + 1 }}
                      <i v-if="check_dot(item.id)" class="custom-marker-dot bg-danger"
                         style="transform: translateX(-4.2vw) translateY(-3vw); scale: 0.4;"></i>
                    </td>
                    <td>
                      {{ item['name'] }}
                    </td>
                    <td>
                      <router-link :to="`/pishkhan/list/user/by/${item.id}/${item.name}`"
                                   class=" w-100 btn btn-primary btn-submit-1">
                        مشاهده کاربران
                      </router-link>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";

export default {
  name: "ListUser",
  components: {Sidebar, Splash},
  data() {
    return {
      all_users: [],
      searchUser: '',
      submitCloneOrganModal: false,
      submitCloneProcessModal: false,
      submitCloneTaskModal: false,
      cLists: [],
    }
  },
  methods: {
    check_dot(id) {
      for (let i = 0; i < this.cLists.length; i++) {
        if (this.cLists[i].company_id === id) {
          return true;
        }
      }
      return false; // اگر هیچ موردی پیدا نشد، false برگردانده می‌شود
    },
    fetchItems() {
      this.all_users.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all_for_mother`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result) {
              if (result['users'].length !== 0) {
                result['users'].forEach(item => {
                  this.all_users.push(item)

                })

              }
              if (result.complate1) {
                if (this.$router.options.history.state.back === '/Financial_management_and_productivity/Determining_the_mission') {
                  this.cLists = [...result.complate1]
                }

              }
              if (result.complate2) {
                if (this.$router.options.history.state.back === '/problem_analysis/Problem_identification') {

                  this.cLists = [...result.complate2]
                }

              }
              if (result.complate3) {
                if (this.$router.options.history.state.back === '/problem_analysis/Prioritizing_issue') {

                  this.cLists = [...result.complate3]
                }

              }
              if (result.complate4) {
                if (this.$router.options.history.state.back === '/problem_analysis/The_root_causes_of_the_problem') {

                  this.cLists = [...result.complate4]
                }

              }
              if (result.complate5) {
                if (this.$router.options.history.state.back === '/problem_analysis/Definition_of_basic_measures') {
                  this.cLists = [...result.complate5]

                }

              }

              if (result.complate7) {
                if (this.$router.options.history.state.back === '/problem_analysis/device_monitoring_and_care') {
                  this.cLists = [...result.complate7]
                }
              }
              if (result.complate8) {
                if (this.$router.options.history.state.back === '/executive_elements') {
                  this.cLists = [...result.complate8]
                }
              }
            }

          })
          .catch();
    },

    checkIsMother() {
      if (!this.$cookies.isKey('is_mother')) {
        router.push('/')
      }
    }
  },
  mounted() {
    this.checkIsMother()
    this.fetchItems()
  },
  computed: {
    filteredItems() {
      return this.all_users.filter(item => {
        return (
            item['name'].includes(this.searchUser)
        );
      });
    },
  }
}
</script>

<style scoped lang="scss">
label {
  width: 100%;
  text-align: right;
}


p, label {
  font-size: 1vw !important;
}

input[type=checkbox] {
  width: 1vw;
  height: 1vw;
  border-radius: .5vw;
  border: .2vw solid #eee;
}

.text-end {
  font-weight: bold;
}

.change_div {
  background: #fff;
  width: 20vw;
  padding: 1vw;
  margin-left: 5vw;
  border-radius: 1vw;
}
</style>